import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
// import { requestForToken, onMessageListener, messaging } from "./firebase";
// Components
import LoginPage from './Pages/Login/login';
import Forgotpassword from './Pages/Login/forgotPassword';
import Home from './Pages/home/home';
import HealthSurvey from './Pages/survey/HealthSurvey';
import Navbar from './Pages/navbar/index';
import {
  DailyBreathing,
  RejuvenateSounds,
  EchoSoundscapes,
  SoundMeditation
} from './Pages/care/care';
import SleepStories from './Pages/care/sleep-stories';
import MoodCheckin from './Pages/care/mood-checkin';
import GratitudeJournal from './Pages/care/GratitudeJournal';
import Care from './Pages/care/care';
import Converse from './Pages/converse/converse';
import AppointmentBooking from './Pages/consult/AppointmentBooking';
import Profile from './Pages/home/Profile';
import Progress from "./Pages/home/Progress";
import LearnWithEcho from "./Pages/home/LearnwithEcho";
import FamilyDetails from "./Pages/home/FamilyDetails";
import MyAppointments from './Pages/home/Appointment';
import ResetPassword from './Pages/Login/resetPassword';
import TestNotification from './TestNotification.jsx';
import LandingPage from './Pages/Login/landingPage.jsx';
import Insights from './Pages/home/Insights.jsx';
import AssessmentInsight from './Pages/home/assessmentInsight.jsx';
import { postUserUsageTime } from './service/insights.js';
import SoundTherapy from './Pages/home/SoundTherapy.jsx';
import EchoSounds from './Pages/care/echo-sounds.jsx';
import EAPWellnessIndex from './Pages/home/Assessment.jsx';
import { updateFcmToken } from './service/user.js';
import DecodeStress from "./Pages/home/decodeStress.jsx";
import AssessmentFlow from "./Pages/home/AssessmentFlow";
import ResultPage from "./Pages/home/ResultPage";
import AssessmentSelection from './Pages/survey/AssesmentSelection.jsx';
import SelfCareCampaign from './Pages/home/Selfcarecampaign.jsx';
import WellnessCampaign from './Pages/home/Wellnesscampaign.jsx';

function ProtectedRoute({ children, allowedFor }) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const expiry = localStorage.getItem("userExpiry");
  const now = new Date().getTime();

  const isLoggedIn = user && expiry && now < parseInt(expiry, 10);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Layout
function AppLayout() {
  const location = useLocation();

  const user = localStorage.getItem("user");
  const expiry = localStorage.getItem("userExpiry");
  const now = new Date().getTime();
  const userData = user ? JSON.parse(user) : null;
  const accountType = userData?.account_type;

  const userId = Number(localStorage.getItem("user_id"));

  const sessionStartRef = useRef(Date.now());
  const apiCalledRef = useRef(false);
  const fiveMinTimerRef = useRef(null);

  useEffect(() => {
    if (!userId) return;

    // ⏱ Start 5-minute timer
    fiveMinTimerRef.current = setTimeout(() => {
      if (!apiCalledRef.current) {
        postUserUsageTime(userId, 300);
        apiCalledRef.current = true;
      }
    }, 5 * 60 * 1000); // 5 minutes

    // 🔴 Handle page unload / refresh / close
    const handleUnload = () => {
      if (apiCalledRef.current) return;

      const timeSpentSeconds = Math.floor(
        (Date.now() - sessionStartRef.current) / 1000
      );

      if (timeSpentSeconds > 0) {
        postUserUsageTime(userId, timeSpentSeconds);
        apiCalledRef.current = true;
      }
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      clearTimeout(fiveMinTimerRef.current);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [userId]);

  const isLoggedIn = user && expiry && now < parseInt(expiry, 10);

  // useEffect(() => {
  //   // Helper to calculate the delay until the next 6:25 PM
  //   const getDelayUntilTime = (hours, minutes) => {
  //     const now = new Date();
  //     const target = new Date();
  //     target.setHours(hours, minutes, 0, 0); // set target time today

  //     // If target time has already passed today, schedule for tomorrow
  //     if (target <= now) {
  //       target.setDate(target.getDate() + 1);
  //     }

  //     return target - now; // milliseconds until next trigger
  //   };

  //   // Function to show a custom notification
  //   const showDailyNotification = () => {
  //     alert("💪 Rise and shine! Be ready for your 7:30 AM echoBuddy Morning Yoga session — let’s flow into the day!"); // or use Notification API
  //     console.log("💪 Rise and shine! Be ready for your 7:30 AM echoBuddy Morning Yoga session — let’s flow into the day!");

  //     // Schedule next notification for the same time tomorrow
  //     const delay = 24 * 60 * 60 * 1000; // 24 hours
  //     setTimeout(showDailyNotification, delay);
  //   };

  //   // Schedule the first notification at 7:15 PM
  //   const initialDelay = getDelayUntilTime(7, 15);
  //   setTimeout(showDailyNotification, initialDelay);

  //   // Your existing service worker + FCM logic
  //   if ("serviceWorker" in navigator) {
  //     navigator.serviceWorker
  //       .register("/firebase-messaging-sw.js")
  //       .then(async (registration) => {
  //         console.log("✅ Firebase service worker registered:", registration);

  //         const sw = await navigator.serviceWorker.ready;
  //         const token = await requestForToken(sw);

  //         if (token) {
  //           console.log("🎯 New FCM Token:", token);

  //           const user = JSON.parse(localStorage.getItem("user"));
  //           if (user?.id) {
  //             await fetch("https://api.echobuddy.in/api/v1/save-token", {
  //               method: "POST",
  //               headers: { "Content-Type": "application/json" },
  //               body: JSON.stringify({ user_id: user.id, token }),
  //             });
  //             console.log("✅ Token saved to backend!");
  //           }
  //         } else {
  //           console.warn("⚠️ No registration token available.");
  //         }

  //         onMessageListener()
  //           .then((payload) => {
  //             console.log("🔔 Notification in foreground:", payload);
  //             alert(payload?.notification?.title || "New Notification!");
  //           })
  //           .catch((err) => console.error("Message listener error:", err));
  //       })
  //       .catch((err) => {
  //         console.error("❌ Service worker registration failed:", err);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    if (location.pathname === "/home" && isLoggedIn) {

      window.showAlert = function () {
        alert('Hello from React (Home Page)');
      };

    } else {
      delete window.showAlert;
    }

    return () => {
      delete window.showAlert;
    };
  }, [location.pathname, isLoggedIn]);

  // useEffect(() => {
  //   console.log('receiveDataFromApp called:');
  //   window.receiveDataFromApp = async function (data) {
  //     console.log('inside receiveDataFromApp',);
  //     console.log('Data from Flutter:', data);

  //     const token = data?.token;
  //     const userId = data?.userId;
  //     const email = data?.email;

  //     if (!token || !userId || !email) {
  //       console.error("❌ Missing token or userId or email");
  //       return;
  //     }

  //     try {
  //       const result = await updateFcmToken(userId, token);
  //       console.log("📡 Backend Response:", result);

  //       console.log(
  //         `Firebase Token Saved!
  //          Token: ${token}
  //          User ID: ${userId}
  //          Message: ${email}`
  //       );

  //       alert(
  //         `Firebase Token Saved!
  //          Token: ${token}
  //          User ID: ${userId}
  //          Message: ${email}`
  //       );
  //     } catch (err) {
  //       console.error("❌ Error updating FCM token:", err);
  //       alert(`Failed to save FCM token to backend.\n${err.message}`);
  //     }
  //   };

  //   return () => {
  //     delete window.receiveDataFromApp;
  //   };
  // }, []);

  useEffect(() => {
    const isEchoBuddyApp = navigator.userAgent.includes('echoBuddyAppWebView');

    window.receiveDataFromApp = async function (data) {
      if (!isEchoBuddyApp) {
        console.log('receiveDataFromApp ignored: not opened from mobile app');
        return;
      }

      // console.log('inside receiveDataFromApp');
      // console.log('Data from Flutter:', data);

      const token = data?.token;
      const userId = data?.userId;
      const email = data?.email;

      if (!token || !userId || !email) {
        console.error('Missing token or userId or email');
        return;
      }

      try {
        const result = await updateFcmToken(userId, token);
        console.log('Backend Response:', result);

        // 				console.log(`Firebase Token Saved!
        // Token: ${token}
        // User ID: ${userId}
        // Message: ${email}`);

        // 				alert(`Firebase Token Saved!
        // Token: ${token}
        // User ID: ${userId}
        // Message: ${email}`);
      } catch (err) {
        console.error('Error updating FCM token:', err);
        alert(`Failed to save FCM token to backend.\n${err.message}`);
      }
    };

    return () => {
      delete window.receiveDataFromApp;
    };
  }, []);

  return (
    <>
      {/* Show Navbar only on specific routes */}
      {[
        '/home',
        '/care',
        '/echo-sounds',
        '/converse',
        '/appointmentbooking',
        '/consult',
        '/echosound',
        '/daily-breathing',
        '/rejuvenate-sounds',
        '/echo-soundscapes',
        '/sound-meditation',
        '/sleep-stories',
        '/mood-checkin',
        '/gratitude-checkin',
        '/profile',
        '/insights',
        '/appointments',
        '/family',
        '/counseller',
        '/veiwappointments',
        '/HealthSurvey',
        '/admin',
        '/admin/appointments',
        '/health-survey',
        '/assessment-selection',
        '/decode-stress',
        '/assessment-flow',
        '/result',
      ].includes(location.pathname) && <Navbar />}

      <Routes>
        {/* 🟢 Public routes – accessible to everyone */}
        <Route path="/" element={isLoggedIn ? <Navigate to={"/home"} replace /> : <LoginPage />} />
        {/* <Route path="/" element={isLoggedIn ? <Navigate to={"/home"} replace /> : <LandingPage />} /> */}

        <Route path="/forgotpassword" element={<Forgotpassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />

        {/* 🔵 User-only routes */}
        <Route
          path="/home"
          element={
            <ProtectedRoute allowedFor="user">
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sound-therapy"
          element={
            <SoundTherapy />
          }
        />
         <Route
          path="/self-care-campaign"
          element={
            <ProtectedRoute allowedFor="user">
              <SelfCareCampaign />
            </ProtectedRoute>
          }
        />
        <Route
          path="/care"
          element={
            <ProtectedRoute allowedFor="user">
              <Care />
            </ProtectedRoute>
          }
        />
        <Route
          path="/converse"
          element={
            <ProtectedRoute allowedFor="user">
              <Converse />
            </ProtectedRoute>
          }
        />
        {/* <Route
					path="/test-notify"
					element={
						<ProtectedRoute allowedFor="user">
							<TestNotification />
						</ProtectedRoute>
					}
				/> */}
        <Route
          path="/consult"
          element={
            <ProtectedRoute allowedFor="user">
              <AppointmentBooking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/insights"
          element={
            <ProtectedRoute allowedFor="user">
              <Insights />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assessment-insights"
          element={
            <ProtectedRoute allowedFor="user">
              <AssessmentInsight />
            </ProtectedRoute>
          }
        />
        <Route
          path="/daily-breathing"
          element={
            <ProtectedRoute allowedFor="user">
              <DailyBreathing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rejuvenate-sounds"
          element={
            <ProtectedRoute allowedFor="user">
              <RejuvenateSounds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/echo-soundscapes"
          element={
            <ProtectedRoute allowedFor="user">
              <EchoSoundscapes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/echo-sounds"
          element={
            <ProtectedRoute allowedFor="user">
              <EchoSounds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/decode-stress"
          element={
            <ProtectedRoute allowedFor="user">
              <DecodeStress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assessment-flow"
          element={
            <ProtectedRoute allowedFor="user">
              <AssessmentFlow />
            </ProtectedRoute>
          }
        />
        <Route
          path="/result"
          element={
            <ProtectedRoute allowedFor="user">
              <ResultPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sound-meditation"
          element={
            <ProtectedRoute allowedFor="user">
              <SoundMeditation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sleep-stories"
          element={
            <ProtectedRoute allowedFor="user">
              <SleepStories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mood-checkin"
          element={
            <ProtectedRoute allowedFor="user">
              <MoodCheckin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gratitude-checkin"
          element={
            <ProtectedRoute allowedFor="user">
              <GratitudeJournal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/insights"
          element={
            <ProtectedRoute allowedFor="user">
              <Progress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/WellnessCampaign"
          element={
            <ProtectedRoute allowedFor="user">
              <WellnessCampaign />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedFor="user">
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointments"
          element={
            <ProtectedRoute allowedFor="user">
              <MyAppointments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/learn-with-echo"
          element={
            <ProtectedRoute allowedFor="user">
              <LearnWithEcho />
            </ProtectedRoute>
          }
        />
        <Route
          path="/family"
          element={
            <ProtectedRoute allowedFor="user">
              <FamilyDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/HealthSurvey"
          element={
            <ProtectedRoute allowedFor="user">
              <HealthSurvey />
            </ProtectedRoute>
          }
        />
        <Route
          path="/health-survey"
          element={
            <ProtectedRoute allowedFor="user">
              <EAPWellnessIndex />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assessment-selection"
          element={
            <ProtectedRoute allowedFor="user">
              <AssessmentSelection />
            </ProtectedRoute>
          }
        />

        {/* 🔴 Default fallback – if user tries an invalid path */}
        <Route
          path="*"
          element={
            isLoggedIn ? (
              <Navigate to="/home" replace />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>

    </>
  );
}

// Main App
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppLayout />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
